let Slider = {
  baseStyle: {
    container: {
      cursor: "pointer",
      width: "100%",
      _disabled: {
        opacity: 0.6,
        cursor: "default",
        pointerEvents: "none"
      }
    },
    track: {
      bg: "grayscale.50",
      overflow: "hidden",
      height: "0.25rem",
      width: "100%",
      borderRadius: "0.125rem",
      _dark: {
        bg: "grayscale.700"
      }
    },
    thumb: {
      top: "50%",
      transform: `translateY(-50%)`,
      bg: "white",
      border: "1px solid",
      borderColor: "rgba(0, 0, 0, 0.1)",
      boxShadow: "0 0 0.45rem rgba(0, 0, 0, 0.3)",
      height: "1.5rem",
      width: "1.5rem",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "absolute",
      outline: 0,
      zIndex: 1,
      borderRadius: "50%",
      transitionProperty: "transform",
      transitionDuration: "normal",
      _after: {
        content: "''",
        position: "absolute",
        height: "100%",
        width: "100%",
        borderColor: "transparent",
        transition: "border-color 120ms ease-in-out 0s"
      },
      _focusVisible: {
        _after: {
          border: "0.125rem solid",
          borderColor: "blue.500",
          borderRadius: "50%",
          padding: "0.125rem"
        }
      },
      _disabled: {
        bg: "gray.300"
      }
    },
    filledTrack: {
      bg: "blue.500",
      width: "inherit",
      height: "inherit"
    },
    mark: {
      fontSize: "text-xs",
      top: "50%",
      transform: `translateX(-50%) translateY(50%)`,
      pt: "0.25rem"
    }
  }
};

export { Slider };
